import { LOCAL_STORAGE_SALT_KEY, MODE } from "../api/static.data.pnp";
const CryptoJS = require("crypto-js");

export const decryptLocalStorage = (encryptData) => {
    if (MODE === "DEV") {
        if (encryptData) {
            try {
                return JSON.parse(encryptData);
            } catch (error) {
                localStorage.clear();
            }
        }
        return null;
    }
    if (typeof window === "undefined") {
        return null
    }
    if (typeof window !== 'undefined') {
        if (encryptData == null) return null;
        let decrypted = CryptoJS.AES.decrypt(encryptData, LOCAL_STORAGE_SALT_KEY);
        try {
            let data = decrypted?.toString(CryptoJS.enc.Utf8);
            encryptData = JSON.parse(data);
        } catch (e) {
            localStorage.clear();
        }
        return encryptData;
    }
}

export const encryptLocalStorage = (storageKey, data) => {
    if (MODE === "DEV") {
        localStorage.setItem(storageKey, JSON.stringify(data));
        return;
    }
    let stringData = JSON.stringify(data);
    let encrypted = CryptoJS.AES.encrypt(stringData, LOCAL_STORAGE_SALT_KEY);
    localStorage.setItem(storageKey, encrypted);
    return;
}